import axios from '@/http/apiRequest'

const baseURL = process.env.VUE_APP_FILE_API
const headers = { 'Content-Type': 'application/json' }

export const getFiles = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/ls',
    data,
  })
}

export const createFile = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/touch',
    data,
  })
}

export const createFolder = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/mkdir',
    data,
  })
}

export const destory = (data) => {
  const _data = { with_self: false, ...data }
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/rm',
    data: _data,
  })
}

// 重命名/剪切
export const rename = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/rename',
    data,
  })
}

export const copy = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/cp',
    data,
  })
}

export const upload = (data, path, headers = {}) => {
  return axios.request({
    baseURL,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...headers,
    },
    method: 'POST',
    url: '/upload?path=' + path,
    data,
  })
}

// 下载文件
export const download = (data, onProgress?) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/download',
    responseType: 'blob',
    onProgress,
    data,
  })
}

// 压缩下载/打包下载
export const downloadZip = (data, onProgress?) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/zip',
    responseType: 'blob',
    onProgress,
    data,
  })
}

// 解压缩
export const unzip = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/unzip',
    data,
  })
}

// 返回文件内容
export const find = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/cat',
    data,
  })
}

// 写入字符串至文件
export const edit = (data) => {
  return axios.request({
    baseURL,
    headers,
    method: 'POST',
    url: '/echo',
    data,
  })
}


// 文件管理初始化接口
export const initial = () => {
  return axios.request({
    method: 'GET',
    url: process.env.VUE_APP_API + '/api/vhost/jumpFileManage'
  })
}
